import {
  Component,
  Input,
  OnInit,
  Output,
  ViewChild,
  EventEmitter,
} from "@angular/core";
import { CoreService } from "../../services/core.service";
import { MessagePopupComponent } from "../MessagePopup/MessagePopup.component";
import { PageName } from "../../helpers/helper.common";
import { NgStyle, AsyncPipe } from "@angular/common";

import { select, Store } from "@ngrx/store";
import { IAppState } from "src/app/store/states/app.state";
import { GetCategories } from "src/app/store/actions/category.actions";
import { NgSelectModule } from "@ng-select/ng-select";
import { ProductList } from "../../models/productlist.model";
import { ProductPagemodel } from "../../pageModels/productPage";
import {
  selectAllProductList,
  selectProductList,
} from "src/app/store/selectors/product.selector";
import {
  BehaviorSubject,
  catchError,
  debounceTime,
  distinctUntilChanged,
  filter,
  map,
  Observable,
  of,
  Subject,
  switchMap,
  tap,
  throwError,
} from "rxjs";
import {
  GetAllProduct,
  GetProduct,
} from "src/app/store/actions/product.actions";
import { ProductsComponent } from "../../../products/products/products.component";
import { AddProductComponent } from "src/app/products/products/add-product/add-product.component";
import { ProductService } from "../../services/product.service";
import { FormsModule } from "@angular/forms";
import { HttpClient } from "@angular/common/http";

@Component({
  selector: "app-openaboutbasket",
  templateUrl: "./OpenAbout_Basket.component.html",
  styleUrls: ["./OpenAbout_Basket.component.scss"],
  standalone: true,
  imports: [
    NgStyle,
    MessagePopupComponent,
    AsyncPipe,
    NgSelectModule,
    ProductsComponent,
    AddProductComponent,
    FormsModule,
  ],
})
export class OpenAboutBasketComponent implements OnInit {
  @ViewChild(MessagePopupComponent) OpenMessage: MessagePopupComponent; // Reference to the MessagePopupComponent
  @Output() messageEvent: EventEmitter<Object> = new EventEmitter<Object>();
  @Output() openPopup: EventEmitter<Object> = new EventEmitter<Object>();
  @Input() page: PageName; // Input to receive the current page
  @Input() isShareAndSave: boolean; // Input to receive the current page
  NavigateTitle = "About"; // Default navigate title
  currentBasket = this.coreService.currentBasket; // Reference to the current basket
  Merchant$ = this.coreService.Merchant$; // Observable for Merchant
  ProductSearch;
  product;
  ProductVisible = false;
  products: ProductList[];

  subject = new BehaviorSubject<any>([]);
  people$ = this.subject.asObservable();
  peopleLoading = false;
  peopleInput$ = new Subject<string>();

  Products$ = this._store.pipe(select(selectAllProductList));
  loading = false;
  tempBool = false;
  input$ = new Subject<string>();
  AddProductVisible;
  ButtonColor = this.coreService.ButtonColor$;
  selectedProduct: any = null; // Holds the selected product
  lastSearchTerm: string = "";
  lastPage: number = 1;
  searchTerm;

  movies$: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);
  moviesLoading = false;
  moviesInput$ = new Subject<string>();
  selectedMovie: any;
  minLengthTerm = 0;

  currentPage: number = 1; // Start with the first page
  isLoadingMore: boolean = false;
  viewOnly;

  constructor(
    private coreService: CoreService,
    private _store: Store<IAppState>,
    private productService: ProductService,
    private http: HttpClient,
  ) {}

  /**
   * Lifecycle hook that is called after the component has been initialized.
   */
  async ngOnInit() {
    this.coreService.basket$.subscribe((data) => {
      this.currentBasket = data; // Update the current basket with the received data
    });

    this.coreService.Merchant$.subscribe((data) => {
      if (data?.webapp_settings) {
        //viewOnly flag used to prevent ordering funtionality

        if (CoreService.MultiOutlet) {
          if (data?.webapp_settings?.is_non_clickable_product_multi_outlet) {
            this.viewOnly =
              data?.webapp_settings?.is_non_clickable_product_multi_outlet;
          }
        } else {
          if (data?.webapp_settings?.is_non_clickable_product) {
            this.viewOnly = data?.webapp_settings?.is_non_clickable_product;
          }
          if (data?.webapp_settings?.is_non_clickable_product_outlet) {
            this.viewOnly =
              data?.webapp_settings?.is_non_clickable_product_outlet;
          }
        }
      }
    });
    // Determine the NavigateTitle based on the current page
    if (this.page === PageName.Dashboard) {
      this.NavigateTitle = "Explore";
    } else if (
      this.page === PageName.Category ||
      this.page === PageName.SubCategory ||
      this.page === PageName.Product
    ) {
      this.NavigateTitle = "Menu";
    }
    if (this.products == undefined) {
      // this._store.dispatch(new GetAllProduct());
      // this.Products$.subscribe((data) => {
      //   if (data) {
      //     // this.products = data;
      //   }
      // });
    }
  }

  trackByFn(item: ProductList) {
    return item.name;
  }

  private loadPeople() {
    this.moviesInput$
      .pipe(
        filter((term) => term !== null && term.length >= this.minLengthTerm), // Ensure minimum length
        distinctUntilChanged(), // Ignore duplicate inputs
        debounceTime(300), // Debounce for smoother experience
        tap(() => {
          this.moviesLoading = true;
          this.currentPage = 1;
        }), // Set loading state
        switchMap((term) => {
          return this.searchProducts(term).pipe(
            catchError(() => of([])), // Return an empty array on error
            tap(() => (this.moviesLoading = false)), // End loading state
          );
        }),
      )
      .subscribe((newMovies) => {
        // Append the new movies to the existing list

        const currentMovies = this.movies$.getValue(); // Get current products
        this.movies$.next([...newMovies]); // Update BehaviorSubject
      });

    // Optionally, you can load initial data here
    this.searchProducts().subscribe((initialMovies) => {
      this.movies$.next(initialMovies); // Set initial data in BehaviorSubject
    });
  }

  // hexToRgba(hex: string, opacity: number): string {
  //   if (!hex) {
  //     return `rgba(255,255,255,${opacity / 100})`;
  //   }

  //   hex = hex.replace("#", "");

  //   if (hex.length === 3) {
  //     hex = hex
  //       .split("")
  //       .map((x) => x + x)
  //       .join("");
  //   }

  //   const r = parseInt(hex.substring(0, 2), 16);
  //   const g = parseInt(hex.substring(2, 4), 16);
  //   const b = parseInt(hex.substring(4, 6), 16);

  //   return `rgba(${r}, ${g}, ${b}, ${(opacity ?? 20) / 100})`;
  // }

  searchProducts(term: string = "", page: number = 1): Observable<any> {
    this.searchTerm = term;
    return this.productService.searchProducts(term, page);
  }

  FetchMore() {
    if (this.isLoadingMore) {
      return; // Prevent multiple calls if still loading
    }

    this.isLoadingMore = true; // Set loading state
    this.currentPage++; // Increment page number

    this.moviesInput$.pipe(map((resp) => {}));
    this.searchProducts(this.searchTerm, this.currentPage).subscribe({
      next: (newMovies) => {
        if (newMovies && newMovies.length > 0) {
          const currentMovies = this.movies$.getValue(); // Get the current products
          this.movies$.next([...currentMovies, ...newMovies]); // Append new data
        } else {
          console.log("No more products to load"); // Optional: log if no new products
        }
        this.isLoadingMore = false; // Reset loading flag
      },
      error: (err) => {
        console.error("Error fetching more products:", err); // Handle error
        this.isLoadingMore = false; // Reset loading flag
      },
    });
  }

  private readonly MIN_TINT = 0; // minimum brand-color visibility floor (0-100)

  hexToRgba(hex: string, opacityPct: number): string {
    if (!hex) return "rgba(0,0,0,0)";
    hex = hex.replace("#", "");
    if (hex.length === 3)
      hex = hex
        .split("")
        .map((c) => c + c)
        .join("");
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);
    const a = Math.max(0, Math.min(100, opacityPct)) / 100;
    return `rgba(${r},${g},${b},${a})`;
  }

  getGlassButtonStyle(merchant: any, extraStyles: any = {}) {
    const settings = merchant?.webapp_settings;
    if (!settings) return {};

    const opacity = settings.footer_bar_opacity ?? 100;
    const menuColor = settings.menu_color || "#000000";

    const alpha = Math.max(0, Math.min(100, opacity)) / 100;

    const blurAmount = Math.max(0, (100 - opacity) / 100) * 20;
    const useBlur = blurAmount > 1;

    const sheenTop = 0.1 + (1 - alpha) * 0.25;
    const sheenBottom = 0.02 + (1 - alpha) * 0.06;

    const clampedOpacity = Math.max(opacity, this.MIN_TINT);
    const clampedOpacityLighter = Math.max(
      Math.min(100, opacity + 15),
      this.MIN_TINT,
    );

    const tintedColor = this.hexToRgba(menuColor, clampedOpacity);
    const tintedColorLighter = this.hexToRgba(menuColor, clampedOpacityLighter);

    const background =
      `linear-gradient(135deg, rgba(255,255,255,${sheenTop}), rgba(255,255,255,${sheenBottom})), ` +
      `linear-gradient(${tintedColorLighter}, ${tintedColor})`;

    // KEY FIX: brightness + saturate make the backdrop visibly different
    // even when the page behind is a flat color identical to the button.
    // Pure blur() cannot do this on a flat/uniform background.
    const backdropFilterValue = useBlur
      ? `blur(${blurAmount}px) brightness(1.18) saturate(1.15)`
      : "none";

    return {
      background,
      border:
        (settings.menu_border_width || 1) + "px solid" + settings.menu_border_color,
      "backdrop-filter": backdropFilterValue,
      "-webkit-backdrop-filter": backdropFilterValue,
      "box-shadow": useBlur
        ? "0 8px 20px rgba(0,0,0,0.18), inset 0 1px 1px rgba(255,255,255,0.45), inset 0 -1px 1px rgba(0,0,0,0.08)"
        : "inset 0 1px 1px rgba(255,255,255,0.4)",
      position: "relative",
      overflow: "hidden",
      ...extraStyles,
    };
  }

  /**
   * Method to navigate to the appropriate page based on the current page.
   */
  NavigateTo() {
    if (this.page === PageName.Dashboard) {
      this.coreService.navigateTo("/about");
    } else if (
      this.page === PageName.Product ||
      this.page === PageName.SubCategory
    ) {
      this._store.dispatch(new GetCategories(""));
      setTimeout(() => {
        this.coreService.navigateTo("/category");
      }, 300);
    }
  }

  OpenPopup() {
    this.openPopup.emit();
  }

  /**
   * Method to check and open the basket.
   * If there are items in the current basket, navigate to '/basket';
   * Otherwise, open a message popup with the provided message.
   */
  OpenBasket() {
    if (this.currentBasket != null && this.currentBasket.items.length > 0) {
      this.coreService.navigateTo("/basket"); // Navigate to the basket page
    } else {
      this.Open("No open orders currently."); // Open a message popup with the specified message
    }
  }

  /**
   * Method to open a message popup with the provided message.
   * @param Message The message to display in the message popup.
   */
  Open(Message: string) {
    this.OpenMessage.Openpopup(Message); // Open the message popup with the provided message
  }

  OpenSmartSearch() {
    // Only load people if not already loaded
    this.searchProducts().subscribe((movies) => {
      this.movies$.next(movies); // Set the initial data in BehaviorSubject
    });

    this.loadPeople();

    this.ProductSearch = true;
  }

  CloseSmartSearch() {
    this.resetSelectionAndList();
    this.ProductSearch = false;
  }

  OnSearch() {
    this.input$
      .pipe(
        switchMap((term) =>
          this.productService.searchProducts(term, this.page),
        ),
      )
      .subscribe((products) => {
        this.products = products; // Ensure it's an array
      });
  }

  OpenProduct(content, Id) {
    this.resetSelectionAndList();
    this.AddProductVisible = true;
    if (this.ProductVisible) {
      this.tempBool = !this.tempBool;
    }
    this.ProductVisible = true;
    this.product = content;
    this.ProductSearch = false;

    // this.messageEvent.emit(content);
  }

  resetSelectionAndList() {
    this.selectedMovie = null; // Reset the selected item
    this.movies$ = new BehaviorSubject([]); // Clear the list
    this.loadPeople(); // Re-fetch or reload the list if needed
  }
}
